<template>
  <CollectionsList type="recordings" title="Recordings Collections" description="A list of all the Recordings Collections in your account"></CollectionsList>
</template>
<script setup>
  import CollectionsList from '@/components/Collections/CollectionsList.vue';
</script>
